import { DialogActions, DialogContent, DialogTitle as MuiDialogTitle, Stack, styled, Typography } from '@mui/material';
import { PropsWithChildren } from 'react';

import CloseDialogButton from './CloseDialogButton';

interface DialogInnerProps {
    onClose?: () => void;
    title?: React.ReactNode;
    subtitle?: React.ReactNode;
    actions?: React.ReactNode;
}

export default function DialogInner({ title, children, onClose, actions, subtitle }: PropsWithChildren<DialogInnerProps>) {
    return (
        <>
            
            { (title || subtitle || onClose) && (
                <MuiDialogTitle>
                    <TitleRow>
                        <Stack>
                            { title }
                            { subtitle && ( <Subtitle>{ subtitle }</Subtitle> ) }
                        </Stack>
                        { onClose && ( <CloseDialogButton onClose={ onClose } /> ) }
                    </TitleRow> 
                   
                </MuiDialogTitle>
            ) }

            <DialogContent>{ children }</DialogContent>

            { actions && (<DialogActions>{ actions }</DialogActions>) }
        </>
    );
}

function Subtitle({ children }: PropsWithChildren) {
    return (
        <Typography variant="subtitle2"
            fontWeight="normal"
            color="text.secondary"
        >
            { children }
        </Typography>
    );
}

const TitleRow = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    rowGap: theme.spacing(1),
    justifyContent: 'space-between'
}));
